// EventContext.js
import React, { createContext, useContext, useState } from 'react';

const EventContext = createContext();

// Provider Component
export function EventProvider({ children }) {
    const [selectedEvent, setSelectedEvent] = useState('');

    return (
        <EventContext.Provider value={{ selectedEvent, setSelectedEvent }}>
            {children}
        </EventContext.Provider>
    );
}

// Custom Hook for Easy Usage
export function useEvent() {
    return useContext(EventContext);
}
